// Global Theme Scripts
document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu toggle logic
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
    });
  }

  // Scroll Animations (Framer Motion Replica)
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const scrollObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, observerOptions);

  document.querySelectorAll('.animate-on-scroll').forEach((el) => {
    scrollObserver.observe(el);
  });

  // Hero Parallax Effect (Framer Motion Replica: heroY = useTransform(scrollY, [0, 1000], [0, 250]))
  const heroImage = document.querySelector('.hero-parallax-img');
  if (heroImage) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          // Calculate parallax: scroll 1000px down maps to 250px translateY
          // Bounded strictly between 0 and 250px to prevent breaking background bounds
          const yPos = Math.min(Math.max((scrollY / 1000) * 250, 0), 250);
          heroImage.style.transform = `translateY(${yPos}px)`;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Setup drawer logic
  console.log('Peppajoy theme initialized.');
});
